import { Wrapper } from '@googlemaps/react-wrapper';
import { Map } from '../Map/Map';
import { Marker } from '../Map/MapElements/MapMarker';
import { Circle } from '../Map/MapElements/MapCircle';
import styled from 'styled-components';
import { apiKey } from '../../utils/geocoder';
import { toRem } from '../../utils/toRem';
import { shouldUseMapAccuracy } from '../../utils/features';
import { useEffect, useRef } from 'react';

type MapMessageViewProps = {
  longitude: number;
  latitude: number;
  accuracy: number | undefined | null;
  onClick?: () => void;
  modal?: boolean;
  didFetchPhoto?: () => void;
  isSent?: boolean;
  isSameSender?: boolean;
  gestureHandling?: string | null;
};

export const SMapMessageView = styled.div<any>`
  max-width: 100%;
  height: ${props => (props.modal ? '70vh' : '20vh')};
  width: 100vw;
  -webkit-mask-image: -webkit-radial-gradient(white, black);
  border-radius: ${toRem(12)};
`;

const defaultZoom = 18;

export const MapMessageView = (props: MapMessageViewProps) => {
  const {
    longitude = 0,
    latitude = 0,
    accuracy,
    onClick,
    modal,
    didFetchPhoto,
    isSent = false,
    isSameSender = true,
    gestureHandling = 'cooperative',
  } = props;
  const circleRef = useRef<google.maps.Circle>(null);

  useEffect(() => {
    if (!shouldUseMapAccuracy) return;

    setTimeout(() => {
      const circleBounds = circleRef.current?.getBounds();
      const map = circleRef.current?.getMap();
      if (map && circleBounds) map.fitBounds(circleBounds, 20);
    }, 100);
  }, []);

  return (
    <SMapMessageView
      onClick={onClick}
      modal={modal}
      isSent={isSent}
      isSameSender={isSameSender}
      role="mapMessageView"
    >
      <Wrapper apiKey={apiKey!} libraries={['places']}>
        <Map
          center={{
            lat: latitude,
            lng: longitude,
          }}
          zoom={defaultZoom}
          className="fullHeightMap"
          disableDefaultUI
          clickableIcons={false}
          gestureHandling={gestureHandling}
          onBoundsChange={() => {
            if (didFetchPhoto) didFetchPhoto();
          }}
        >
          <Marker position={{ lat: latitude, lng: longitude }} />
          {shouldUseMapAccuracy && accuracy && (
            <Circle ref={circleRef} center={{ lat: latitude, lng: longitude }} radius={accuracy} />
          )}
        </Map>
      </Wrapper>
    </SMapMessageView>
  );
};
